import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxPaginationModule } from 'ngx-pagination';
import { AdministrationRoutingModule } from './administration-routing.module';
import { PendingUsersComponent } from './pending-users/pending-users.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UserViewAndEditComponent } from './user-view-and-edit/user-view-and-edit.component';
import { UserActivationComponent } from './user-activation/user-activation.component';
import { UserSearchComponent } from './user-search/user-search.component';
import { EntityListComponent } from './entity-list/entity-list.component';
import { EntitySearchComponent } from './entity-search/entity-search.component';
import { EntityViewAndEditComponent } from './entity-view-and-edit/entity-view-and-edit.component';
import { CreateEntityBrokerComponent } from './create-entity-broker/create-entity-broker.component';
import { CreateEntityAgentComponent } from './create-entity-agent/create-entity-agent.component';
import { CreateBranchComponent } from './create-branch/create-branch.component';
import { SearchBranchComponent } from './search-branch/search-branch.component';

@NgModule({
  declarations: [
    PendingUsersComponent,
    UsersListComponent,
    UserViewAndEditComponent,
    UserActivationComponent,
    UserSearchComponent,
    EntityListComponent,
    EntitySearchComponent,
    EntityViewAndEditComponent,
    CreateEntityBrokerComponent,
    CreateEntityAgentComponent,
    CreateBranchComponent,
    SearchBranchComponent
  ],
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    NgxPaginationModule,
    MatDatepickerModule,
    MatChipsModule,
    MatCheckboxModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatTableModule,
    MatDialogModule
  ]
})
export class AdministrationModule { }
